export const name = 'gzInputValidation';

export default function gzInputValidation() {
  //noinspection BadExpressionStatementJS
  'ngInject';

  var directive = {
    restrict: 'E',
    scope: {
      msg:'@'
    },
    controller: gzInputValidationController,
    controllerAs: 'vm',
    link: gzInputValidationLinkFunction,
    bindToController: true,
    template: require('./input-validation.jade')
  };

  return directive;

  function gzInputValidationController() {
    var vm = this;
  }

  function gzInputValidationLinkFunction(scope, element) {
    scope.$on('$destroy', destroyHandler);

    function destroyHandler() {

    }
  }

} //gzInputValidation
